import { render, staticRenderFns } from "./ConsensusConflictResolversSetting.vue?vue&type=template&id=6bbe9f4b&"
import script from "./ConsensusConflictResolversSetting.vue?vue&type=script&lang=js&"
export * from "./ConsensusConflictResolversSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports